import { render, staticRenderFns } from "./CategoryContentBannerAttaches.vue?vue&type=template&id=9cdef1f6&scoped=true&"
import script from "./CategoryContentBannerAttaches.vue?vue&type=script&lang=js&"
export * from "./CategoryContentBannerAttaches.vue?vue&type=script&lang=js&"
import style0 from "./CategoryContentBannerAttaches.vue?vue&type=style&index=0&id=9cdef1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdef1f6",
  null
  
)

export default component.exports